import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { Grid } from "../core/components/grid.js";
import { Helper } from "../core/util/helper.js";
import { Config } from "../core/config/config.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { General } from "../../siteManagement/general.js";
import { SheetEventType } from "../../siteManagement/sheet.js";
import { Context } from "../core/components/commonApp.js";
import { StringKeyDictionary } from "../commonInterfaces.js";
import React from "react";
export default class ProjectAssignments extends React.Component<ProjectAssignmentsProps, ProjectAssignmentsState>{

    private projNr: string;
    private translations: StringKeyDictionary<string>;
    private gridOptions: kendo.ui.GridOptions;

    constructor(props: ProjectAssignmentsProps) {
        super(props)
        this.projNr = props.context.keyVal1;
        this.state = {
            gridData: []
        }
        this.initApp();
    }

    private initApp = async () => {
        General.Sheet.Manager.getTopMostSheet().bind(SheetEventType.Custom, (data: { cmd }) => {
            if (data.cmd == "updateAssignments") {
                this.loadAssignments();
            }
        })
        const results = await Promise.all([
            this.loadAssignments(),
            Helper.getTranslations(["WebSMS.Procedure.Key"])
        ]);
        this.translations = results[1].Data;
        this.setGridOptions();
        this.setState({});
    }

    private loadAssignments = async () => {
        const result = await HTTPService.get<JsonResultClass<AssignmentInfo[]>>("Project/GetAllAssignments?projNr=" + this.projNr);
        if (result.Code == 0)
            this.setState({ gridData: result.Data })
        else
            NotificationHelper.showErrorMessage(result.Message)
    }

    private setGridOptions = () => {
        let columns: kendo.ui.GridColumn[] = [
            {
                field: "Id",
                title: this.translations["WebSMS.Procedure.Key"],
                template: `#let url = "${Config.baseUrl}ResourcePlanning/Edit?projNr=" + data.ProjNr + "&pIndex=" + data.PIndex;#<a target="_blank" href="#=url#">#=data.ProjNr#/#=data.PIndex#</a>`
            }
        ];
        columns = columns.concat(this.props.columns)
        this.gridOptions = {
            sortable: true,
            pageable: true,
            groupable: true,
            filterable: true,
            selectable: true,
            resizable: true,
            scrollable: true,
            dataSource: {
                schema: {
                    model: {
                        fields: {
                            Start: { type: "date" },
                            End: { type: "date" }
                        }
                    }
                },
            },
            columns: columns
        };
    }

    private createGrid = () => {
        return (
            <div className="flex-container">
                <Grid
                    data={this.state.gridData}
                    options={this.gridOptions}
                    id="projectAssignments"
                />
            </div>
        );
    }


    render() {
        return Helper.hasValue(this.gridOptions) ? this.createGrid() : null;
    }
}

interface ProjectAssignmentsProps {
    context: Context;
    columns: kendo.ui.GridColumn[]
}

interface ProjectAssignmentsState {
    gridData: AssignmentInfo[]
}

interface AssignmentInfo {
    Id: string
}